import Vue from 'vue'
import VueHotjar from 'vue-hotjar'
import VueCookies from 'vue-cookies'
import VueSweetalert2 from 'vue-sweetalert2'
import VueI18n from 'vue-i18n'

import App from './App.vue'
import store from './store'
import router from './router'

import 'sweetalert2/dist/sweetalert2.min.css'
import '@fontsource/inter/400.css'
import '@fontsource/inter/500.css'
import '@fontsource/inter/600.css'
import '@fontsource/inter/700.css'
import './sass/app.scss'

Vue.config.productionTip = false
Vue.use(VueCookies)
Vue.use(VueI18n)
Vue.use(VueHotjar, {
  id: '3181666',
  isProduction: process.env.NODE_ENV === 'production'
})
Vue.use(VueSweetalert2, {
  customClass: {
    htmlContainer: 'swal-container',
    confirmButton: 'swal-button',
    denyButton: 'swal-button'
  }
})

// unique id generator
Vue.use(vue => {
  let uid = 0
  vue.mixin({ beforeCreate () { this.uidCounter = (uid++).toString() } })
  vue.prototype.$id = function (id) { return `uid-${id}-${this.uidCounter}` }
})

function i18n () {
  const context = require.context('./locales', true, /[a-z0-9-_]+\.json$/i)
  const messages = context
    .keys()
    .map(key => ({ key, locale: key.match(/[a-z0-9-_]+/i)[0] }))
    .reduce(
      (messages, { key, locale }) => ({
        ...messages,
        [locale]: context(key)
      }),
      {}
    )
  if (!Vue.$cookies.isKey('lang')) {
    Vue.$cookies.set('lang', 'en')
  }
  return new VueI18n({
    locale: Vue.$cookies.get('lang'),
    messages
  })
}

new Vue({
  router,
  store,
  i18n: i18n(),
  render: h => h(App)
}).$mount('#app')
